<p-galleria
  [value]="imageList"
  [(visible)]="displayGalleria"
  [responsiveOptions]="responsiveOptions"
  [(activeIndex)]="activeIndex"
  [containerStyle]="{'max-width': '850px'}"
  [numVisible]="7"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [baseZIndex]="100000"
  (close)="closeGalleria()">
  <ng-template pTemplate="item" let-item>
    <img [src]="util.getFilePath() + item" (error)="onImageError($event)" style="width: 100%; display: block;" alt="image">
  </ng-template>
</p-galleria>
<div class="p-mt-2 p-mb-2 items" [ngStyle]="{ 'grid-template-columns': this.imageListGridTemplateColumns }">
  <ng-container *ngIf="videos && videos.length && false">
    <div class="p-col" *ngFor="let video of videos">
      <img class="icon" src="assets/images/test/Rectangle%20201.svg" alt="">
    </div>
  </ng-container>
  <ng-container *ngIf="imageList.length || housingPlans.length">
    <ng-container *ngFor="let photo of carousel; let index = index; let first = first; let last = last">
      <div *ngIf="housingPlans?.length > 0 && !first" class="p-d-flex p-center p-col-4 item" [ngStyle]="itemStyle">
        <ng-container *ngTemplateOutlet="imageTmpl; context: { last, photo, index }"></ng-container>
      </div>
      <div *ngIf="housingPlans?.length === 0 && !first" class="p-d-flex p-center p-col-4 item" [ngStyle]="itemStyle">
        <ng-container *ngTemplateOutlet="imageTmpl; context: { last, photo, index }"></ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #imageTmpl let-last=last let-id=photo let-index=index>
  <p *ngIf="last && totalPhotos > 0">+{{totalPhotos}}</p>
  <div *ngIf="last && totalPhotos > 0" class="p-d-flex p-center overlay" [ngStyle]="itemStyle" (click)="imageClick(index)"></div>
  <app-network-image class="icon" [source]="id" [preview]="true" (click)="imageClick(index)"></app-network-image>
</ng-template>
